import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import clsx from 'clsx';
import { Sparkles } from 'lucide-react';
import { useAuth } from '@/lib/auth';
import { AssistantChat } from './AssistantChat';

/**
 * Schwebender Einstieg zum KI-Assistenten (nur mit Berechtigung assistant.use).
 * Desktop: nicht-modales Panel unten rechts. Mobil: Wechsel auf die Seite /assistent.
 */
export function AssistantLauncher() {
  const { can } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!open) return;
    const onKey = (e: globalThis.KeyboardEvent) => {
      if (e.key === 'Escape' && !document.querySelector('[role="dialog"]')) setOpen(false);
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open]);

  if (!can('assistant.use') || location.pathname.startsWith('/assistent')) return null;

  const toggle = () => {
    if (window.matchMedia('(max-width: 767px)').matches) navigate('/assistent');
    else setOpen((o) => !o);
  };

  return (
    <>
      {open && (
        <div
          className="fixed bottom-36 right-5 z-40 flex h-[min(680px,calc(100vh-11rem))] lg:bottom-20 lg:h-[min(680px,calc(100vh-7rem))] w-[420px] max-w-[calc(100vw-2.5rem)] flex-col overflow-hidden rounded-xl border border-slate-200 bg-white shadow-2xl"
          role="complementary"
          aria-label="KI-Assistent"
        >
          <AssistantChat variant="panel" onClose={() => setOpen(false)} />
        </div>
      )}
      <button
        type="button"
        onClick={toggle}
        className={clsx(
          'bottom-tabbar fixed right-4 z-30 flex h-12 items-center gap-2 rounded-full px-3.5 text-sm font-medium text-white shadow-lg shadow-brand-900/20 transition-transform active:scale-95 print:hidden lg:bottom-5 lg:right-5 lg:px-4',
          open ? 'bg-slate-700 hover:bg-slate-800' : 'bg-brand-700 hover:bg-brand-800',
        )}
        aria-expanded={open}
        aria-label="KI-Assistent öffnen"
        title="KI-Assistent"
      >
        <Sparkles className="h-5 w-5" />
        <span className="hidden lg:inline">{open ? 'Schließen' : 'Assistent'}</span>
      </button>
    </>
  );
}
